import { Box, CssBaseline } from '@mui/material'
import { ThemeProvider } from '@mui/material/styles'
import theme from '../../styles/theme'
import HouseholdOnboardingForm from '../../components/HouseholdOnboardingForm'
import logo from '../../assets/rounded_logo.svg'

export default function HouseholdOnboarding() {
    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <Box
                sx={{
                    backgroundColor: '#FFFA66',
                    minHeight: '100vh',
                    width: '100%',
                    position: 'relative'
                }}
            >
                <Box
                    component="img"
                    src={logo}
                    alt="Heyy Property Logo"
                    sx={{
                        position: 'absolute',
                        top: { xs: 16, sm: 24 },
                        left: { xs: 16, sm: 24 },
                        width: { xs: '80px', sm: '120px' },
                        height: 'auto',
                        zIndex: 1
                    }}
                />
                <HouseholdOnboardingForm isVisible={true} />
            </Box>
        </ThemeProvider>
    )
}
